import { useLocation, useNavigate } from 'react-router-dom'
import { Building, TrendingUp, BarChart3, Trophy, LayoutGrid } from 'lucide-react'
import { confirmLeaveUnsavedChanges } from '@/lib/unsavedChanges'

export function ManagementCompanyNavigation() {
  const location = useLocation()
  const navigate = useNavigate()

  const navItems = [
    {
      path: '/partners',
      icon: BarChart3,
      label: 'Франчайзи',
      enabled: true
    },
    {
      path: '/management-dashboard',
      icon: Building,
      label: 'Дашборд',
      enabled: true
    },
    {
      path: '/management-analytics',
      icon: TrendingUp,
      label: 'Аналитика',
      enabled: true
    },
    {
      path: '/management/hub',
      icon: LayoutGrid,
      label: 'Направления',
      enabled: true
    },
    {
      path: '/management-ratings',
      icon: Trophy,
      label: 'Рейтинги',
      enabled: true
    }
    // {
    //   path: '/admin/notifications',
    //   icon: BellRing,
    //   label: 'Уведомления',
    //   enabled: true
    // }
  ]

  // Этот компонент теперь используется только напрямую в страницах УК
  // Логика показа управляется самими страницами

  return (
    <div className="fixed bottom-0 left-0 right-0 z-30 bg-card border-t border-border px-4 py-2 tg-navigation">
      <div className="flex justify-around">
        {navItems.map((item) => {
          if (!item.enabled) return null
          
          const Icon = item.icon
          const isActive =
            location.pathname === item.path ||
            (item.path === '/management/hub' &&
              location.pathname.startsWith('/management/hub')) ||
            (item.path === '/management-ratings' &&
              location.pathname.startsWith('/management-ratings/'))
          
          return (
            <button
              key={item.path}
              onClick={() => navigate(item.path)}
              disabled={isActive}
              className={`
                flex flex-col items-center p-2 rounded-lg transition-colors
                ${isActive 
                  ? 'text-primary bg-primary/10' 
                  : 'text-muted-foreground hover:text-foreground hover:bg-accent'
                }
              `}
            >
              <Icon size={20} className="mb-1" />
              <span className="text-xs font-medium">{item.label}</span>
            </button>
          )
        })}
      </div>
    </div>
  )
}
